<style type="text/css" scoped lang="less">
.el-dropdown {
	vertical-align: top;
}

.el-dropdown + .el-dropdown {
	margin-left: 15px;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.el-dropdown-link {
	cursor: pointer;
	color: #409eff;
}

.el-icon-arrow-down {
	font-size: 12px;
}

.useruse {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 0.6rem;
	background: #fff;
	border-radius: 2px;
	box-sizing: border-box;
	margin-bottom: 1rem;

	.useruseleft,
	.useruseright {
		display: flex;
		align-items: center;
	}

	.useruseleft > p {
		padding: 0.4rem 0.8rem;
		// box-sizing: border-box;
		border: 1px solid;
		margin-right: 0.6rem;
		text-align: center;
		background: #0a68e3;
		color: #fff;
		font-size: 0.8rem;
		font-weight: 700;
		display: flex;
		align-items: center;
		border-radius: 5px;

		span {
			margin: 0 2px;
		}

		span:first-child {
			font-size: 1rem;
		}
	}

	// .useruseleft>p:first-child:hover {
	// 	background: #0d72ff;
	// }

	// .useruseleft>p:nth-of-type(2):hover {
	// 	background: #11e4f7;
	// }

	// .useruseleft>p:nth-of-type(2) {
	// 	background: #0ec9d6;
	// }

	.useruseleft > p:last-child {
		background: #07b446;
	}

	// .useruseleft>p:last-child:hover {
	// 	background: #07d54f;
	// }

	.useruseright {
		li:nth-of-type(2) {
			/deep/ .el-date-editor {
				height: 2rem;
				width: 16rem;

				i {
					margin-bottom: 8px;
				}

				span {
					margin-bottom: 8px;
				}
			}
		}

		li {
			// height: 1rem;
			margin-right: 0.2rem;
			width: 100%;

			/deep/ .el-dropdown-link.el-dropdown-selfdefine {
				display: flex;
				align-items: center;
				justify-content: space-between;

				span {
					display: block;
					padding: 0.31rem;
					border: 1px solid #e2e2e2;
					color: #585858;
					font-size: 0.8rem;
				}

				i {
					display: block;
					padding: 0.51rem;
					border: 1px solid #dddddd;
					border-left: 0;
					color: #000;
					font-size: 0.8rem;
				}
			}
		}

		li:nth-of-type(3),
		li:nth-of-type(4),
		li:nth-of-type(2) {
			margin-right: 0.4rem;
			// width: 6rem;
		}

		li:nth-of-type(2) {
			span {
				// padding: 0.24rem !important;
			}
		}
	}
}

.tabslis {
	/deep/ & ::-webkit-scrollbar {
		width: 5px;
		height: 8px;
		background: linear-gradient(to right, #2e61bf, #60c363);
	}

	& ::-webkit-scrollbar {
		width: 10px;
		height: 5px;
		// background: red;
	}

	& ::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}

	/deep/ .el-table {
		th,
		td {
			text-align: center;
		}

		tr:nth-child(2n) {
			background-color: #fff;
		}

		tr:nth-child(2n-1) {
			background-color: #f2f2f2;
		}

		td {
			button {
				color: #fff;
				border-radius: 5px;
			}

			.looking {
				background: #0acf97;
				margin-left: 10px;
			}

			.looking:hover {
				background: #0ae8a6;
			}

			.giveempower {
				background: #ff8300;
			}

			.edit {
				background: #169bd5;
			}

			.edit:hover {
				background: #18aceb;
			}

			.delete {
				background: #f2125e;
			}

			.delete:hover {
				background: #ff1365;
			}
		}
	}
}

button {
	color: #fff;
	border-radius: 5px;
}

.looking {
	background: #0acf97;
	margin-left: 10px;
}

.looking:hover {
	background: #0ae8a6;
}

.giveempower {
	background: #ff8300;
}

.edit {
	background: #169bd5;
}

.edit:hover {
	background: #18aceb;
}

.delete {
	background: #f2125e;
}

.delete:hover {
	background: #ff1365;
}

.tablestitilw {
	width: 100%;
	padding: 0.8rem 0.8rem;
	box-sizing: border-box;
	background-color: #f7f7f7;
	color: #333;
	font-size: 0.9rem;
	font-weight: 700;
}

.tables {
	padding: 0 0.8rem 1.2rem 0.8rem;
	background: #fff;
	box-sizing: border-box;

	.paginations {
		height: 3rem;
		line-height: 3rem;

		input {
			width: 3rem;
			height: 1.8rem;
			padding: 0 0 0 0.8rem;
			border: 1px solid #ccc;
		}
	}

	.tabsnum {
		height: 4rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		p {
			color: #333;
		}

		.elpagian {
			margin-right: 1rem;
		}
	}
}

.swipers {
	/deep/ .switchStyle .el-switch__label {
		position: absolute;
		display: none;
		color: #ffffff;
	}

	/deep/ .switchStyle .el-switch__label--left {
		z-index: 9;
		left: 25px;
	}

	/deep/ .switchStyle .el-switch__label--right {
		z-index: 9;
		left: 0px;
		top: 0;
	}

	/deep/ .switchStyle .el-switch__label.is-active {
		display: block;
	}

	/deep/ .switchStyle.el-switch .el-switch__core,
	/deep/ .el-switch .el-switch__label {
		width: 60px !important;
	}
}

/deep/ .el-dialog__header {
	padding: 14px 19px 10px;
	background: #05a34a;
	color: #fff;
	font-size: 1.2rem;

	.el-dialog__headerbtn .el-dialog__close {
		color: #fff;
		font-size: 1.4rem;
	}

	.dialog-header-title {
		span {
			margin-left: 0.6rem;
		}
	}
}

.qxchoex {
	display: flex;
	align-items: center;

	.qxchoexipt {
		padding: 0.4rem 0.4rem;
		border: 1px solid;
		width: 80%;
		box-sizing: border-box;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	/deep/ .el-dropdown {
		button {
			background-color: transparent;
			color: #000;
			height: 1rem;
		}

		.el-dropdown-link {
			color: #000;

			i {
				font-size: 1.2rem;
			}
		}
	}

	/deep/ .el-tag {
		background-color: #22af47;
		border-color: #22af47;
		color: #fff;

		i {
			color: #fff;
		}

		i:hover {
			color: #000;
			background: #fff;
		}
	}
}

.okdiolog {
	background-color: #f0b104;
	border-color: transparent;
}

.okdiolog:hover {
	background-color: #ffbd06;
	color: #000;
}

.clocediolog {
	background-color: #4ec0cc;
	border-color: transparent;
}

.clocediolog:hover {
	background-color: #54d3de;
	color: #000;
}

/deep/ .tablestitle {
	color: #333;

	.cell {
		font-weight: 600 !important;
	}

	// font-size: 1rem;
}
</style>
<template>
	<div>
		<titles titlename="设备电源操作记录" titlecontent="设备电源操作记录" :mbx="paths"></titles>
		<div class="useruse">
			<div class="useruseleft"><!-- <p>操作记录</p> --></div>
			<ul class="useruseright">
				<li class="col-xs-2 col-sm-2 col-md-4 col-lg-4">
					<el-input size="small" @blur="searchs()" v-model="search" placeholder="搜索..." prefix-icon="el-icon-search"></el-input>
				</li>
				<!-- 
				<li>
					<el-date-picker v-model="datetimer" type="datetimerange" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['12:00:00']">
					</el-date-picker>
				</li> -->
			</ul>
		</div>

		<p class="tablestitilw">操作记录</p>
		<div class="tables">
			<div class="tabslist">
				<div class="paginations">
					每页显示
					<input @change="changes()" maxlength="20" type="number" oninput="if(value>30)value=30;if(value<2)value=1" v-model="pagesize" />
					行
				</div>
				<div class="tabslis">
					<template>
						<el-table :data="tableData" header-row-class-name="tablestitle" border style="width: 100%">
							<el-table-column fixed :resizable="false" prop="sx_tpl_number" label="设备编号" width="150"></el-table-column>
							<el-table-column prop="sx_tpl_name" :resizable="false" label="设备名称" width="300"></el-table-column>
							<el-table-column prop="sx_tpl_trainName" :resizable="false" label="实训室名称" width="300"></el-table-column>
							<el-table-column prop="sx_tpl_type" :resizable="false" label="操作内容"></el-table-column>
							<el-table-column prop="sx_tpl_opeartTime" :resizable="false" label="操作时间" width="300"></el-table-column>
							<el-table-column prop="sx_tpl_opearter" :resizable="false" label="操作者"></el-table-column>
						</el-table>
					</template>
				</div>
				<div class="tabsnum">
					<p>
						显示
						<span>1</span>
						到
						<span>{{ pagesize }}</span>
						,共
						<span>{{ pagetotal }}</span>
						条记录
					</p>
					<div class="elpagian">
						<el-pagination @current-change="handleCurrentChange" background layout="prev, pager, next" :page-size="pagesizes" :total="pagetotal"></el-pagination>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :show-close="false" :visible.sync="addshow" :close-on-press-escape="false" :close-on-click-modal="false" width="600px">
			<div slot="title" class="dialog-header-title">
				<i class="el-icon-folder-add"></i>
				<span>修改用户权限（角色）</span>
			</div>
			<div class="qxchoex">
				<p>用户角色：</p>
				<div class="qxchoexipt">
					<el-tag size="mini" closable v-for="(item, index) in qxtaglist" :key="index">{{ item.label }}</el-tag>
				</div>
				<el-dropdown>
					<span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item>人员管理</el-dropdown-item>
						<el-dropdown-item>角色管理</el-dropdown-item>
						<el-dropdown-item>实训室管理</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="okdiolog" @click="addshow = false">确 定</el-button>
				<el-button class="clocediolog" @click="addshow = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';
import { xlsx } from '../../utils/tabgo';
import { getPageTrainPowerLogList } from '@/request/api/trainroom/trainroom.js';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			search: '',
			// 操作记录
			pagenum: 1,
			pagesize: 10,
			pagetotal: 10,
			datetimer: '',
			// 权限列表
			qxtaglist: [
				{
					type: '',
					label: '人员管理'
				}
			],
			// 授权
			addshow: false,

			//导出表格
			listHander: {
				numid: '序号',
				name: '用户名',
				realname: '真实姓名',
				sex: '性别',
				schoolname: '所属学校',
				studs: '状态'
			},
			// 表格数
			tabsnun: 10,
			// 表格
			tableData: [
				{
					numid: '221001-1',
					name: '电源001',
					sxname: '开成楼一楼1001轨道交通智能实训室',
					cztimer: '2022-07-22 10:30:25',
					czuser: '张一鸣',
					users: '上电'
				},
				{
					numid: '221001-1',
					name: '电源001',
					sxname: '开成楼一楼1001轨道交通智能实训室',
					cztimer: '2022-07-22 10:30:25',
					czuser: '张一鸣',
					users: '上电'
				},
				{
					numid: '221001-1',
					name: '电源001',
					sxname: '开成楼一楼1001轨道交通智能实训室',
					cztimer: '2022-07-22 10:30:25',
					czuser: '张一鸣',
					users: '上电'
				},
				{
					numid: '221001-1',
					name: '电源001',
					sxname: '开成楼一楼1001轨道交通智能实训室',
					cztimer: '2022-07-22 10:30:25',
					czuser: '张一鸣',
					users: '上电'
				}
			],

			// 排序选择框
			options: [
				{
					value: '按时间',
					label: '时间'
				},
				{
					value: '按学校',
					label: '学校'
				},
				{
					value: '按性别',
					label: '性别'
				},
				{
					value: '按用户名',
					label: '用户名'
				}
			],
			value: '',
			// 搜索框
			input2: '',
			paths: [
				{
					path: '/Usermanage/stiticenotes',
					name: '实训设备管理'
				},
				{
					path: '/allmanage/stiticenotes',
					name: '设备电源操作记录'
				}
			]
		};
	},
	components: {
		titles
	},
	created() {
		AppOptions.appEmpty = false;
	},
	mounted() {
		this.getTrainPowerLogList();
	},
	computed: {
		pagesizes() {
			return Number(this.pagesize);
		}
	},
	methods: {
		handleCurrentChange(val) {
			console.log(val);
			this.pagenum = val;
			this.getTrainPowerLogList();
		},
		searchs() {
			this.getTrainPowerLogList(this.search);
		},

		// 更改table
		changes() {
			this.getTrainPowerLogList();
		},

		getTrainPowerLogList(search = null) {
			let TrainPowerLogobj = {
				pageIndex: this.pagenum,
				pageSize: this.pagesize,
				sx_tpl_name: search == null ? '' : search,
				sx_tpl_number: ''
			};
			getPageTrainPowerLogList(TrainPowerLogobj).then(res => {
				console.log(res);
				this.pagetotal = res.data.data.totalCount;
				this.tableData = res.data.data.list;
			});
		},

		handleClick(row) {
			console.log(row);
		},
		// 导出表格
		outExcel() {
			console.log('导出表');
			xlsx(this.tableData, this.listHander, '用户表');
		}
	}
};
</script>
